import { Canvas } from "@craftjs/core";

import { define, prop } from "@/components/builder/utils";

import { HeadingBlock, InputBlock, UnsubscribeFormConfirmationBlock, UnsubscribeFormAlertBlock, RecaptchaBlock, GridContainerBlock, GridItemBlock, ConditionBlock, ConditionCaseBlock } from "../..";
import BasePreview from "../../base";

function UnsubscribeFormPreview({ ...props }) {
  return <BasePreview {...props}>
    <div>
      <Canvas
        id="grid-container"
        is={GridContainerBlock}
        properties={{ layoutType: 'grid', grid: { columns: 1, rows: 3, height: 'fitcontent', gap: { all: '4-predefined' } }, size: { width: 'w-full' } }}>
        <Canvas
          is={GridItemBlock}
          properties={{ grid: { itemColumn: 1 } }}
          custom={{ name: 'Heading' }}>
          <Canvas
            is={HeadingBlock}
            properties={{ content: "<h1>Sorry to see you go</h1>", align: { horizontal: 'center' }, fontWeight: 'font-bold' }} />
        </Canvas>
        <Canvas
          is={GridItemBlock}
          properties={{ grid: { itemColumn: 1 } }}
          custom={{ name: 'Confirmation' }}>
          <Canvas
            is={UnsubscribeFormConfirmationBlock}
            properties={{ content: "Do you really want to unsubscribe?", altContent: 'Please {{#if found}}confirm your email <b>{{email}}</b>{{else}}provide your email below{{/if}}.', textAlign: { horizontal: 'center' }, fontSize: 'lg', textColor: 'gray-900', size: { width: 'w-full' } }}
            custom={{ name: 'Text' }} />
        </Canvas>
        <Canvas
          is={GridItemBlock}
          properties={{ grid: { itemColumn: 1 } }}
          custom={{ name: 'Alert' }}>
          <Canvas
            is={UnsubscribeFormAlertBlock}
            properties={{ space: { padding: 'p-3' }, size: { width: "w-full" }, background: { color: "yellow-100" }, border: { radius: { rounded: "sm" }, width: { border: "1px" }, color: "yellow-200" }, className: "relative" }}
            custom={{ name: 'Alert Dialog' }} />
        </Canvas>
        <Canvas
          is={GridItemBlock}
          properties={{ grid: { itemColumn: 1 } }}
          custom={{ name: 'Email' }}>
          <Canvas
            is={ConditionBlock}
            properties={{ condition: '@params.email', show: 'false' }}>
            <Canvas
              is={ConditionCaseBlock}>
              <Canvas
                is={InputBlock}
                properties={{ attributes: { name: "email", type: "hidden", value: "{{@params.email}}", required: true }, content: "Input", space: { padding: 'p-2' } }} />
            </Canvas>
            <Canvas
              is={ConditionCaseBlock}>
              <Canvas
                is={InputBlock}
                properties={{ attributes: { name: "email", type: "text", placeholder: "Please enter your e-mail", required: true }, content: "Input", space: { padding: 'p-2' }, border: { radius: { rounded: "sm" }, width: { border: "1" }, color: "gray-400" }, size: { width: "w-full", height: "min-h-8" } }} />
            </Canvas>
          </Canvas>
        </Canvas>
        <Canvas
          is={GridItemBlock}
          properties={{ grid: { itemColumn: 1 } }}
          custom={{ name: 'Recaptcha' }}>
          <Canvas
            is={RecaptchaBlock}
            origin="unsubscribe" />
        </Canvas>
        <Canvas
          is={GridItemBlock}
          properties={{ grid: { itemColumn: 1 } }}
          custom={{ name: 'Submit' }}>
          <Canvas
            is={InputBlock}
            properties={{ attributes: { value: 'Unsubscribe', name: 'Unsubscribe', type: 'submit' }, className: "cursor-pointer", background: { color: 'blue-500' }, textColor: 'gray-100', space: { padding: 'p-3' }, size: { width: 'w-full' }, border: { radius: { rounded: "sm" } }, fontWeight: 'font-bold' }} />
        </Canvas>
      </Canvas>
    </div>
  </BasePreview>
}

function UnsubscribeFormHTML({ children, attributes }) {
  return <form {...attributes} method="POST" id="form">
    <input type="hidden" name="uid" value="{{@params.uid}}" />
    <input type="hidden" name="i" value="{{@params.i}}" />
    {children}
  </form>
}

export default define('unsubscribe-form', UnsubscribeFormPreview, UnsubscribeFormHTML)
  .property(prop.stylePattern())
  .property(prop.predefined.customClass())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.layout())
  .defaultProps({
    size: { width: 'w-full' },
  })
  .build()
